import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import AdminLayout from "../Admin/componants/AdminLayout";
import AdminDashboard from "../Admin/componants/AdminDashboard";
import AdminCourses from "../Admin/pages/AdminCourses";
import AdminBatches from "../Admin/pages/AdminBatches";
import AdminStudents from "../Admin/pages/AdminStudents";
import AdminTeachers from "../Admin/pages/AdminTeachers";
import AdminQuestionBank from "../Admin/pages/AdminQuestionBank";
import AdminTestSeries from "../Admin/pages/AdminTestSeries";
import AdminLiveClasses from "../Admin/pages/AdminLiveClasses";
import AdminPayments from "../Admin/pages/AdminPayments";
import AdminReports from "../Admin/pages/AdminReports";
import AdminSettings from "../Admin/pages/AdminSettings";
import { getAdminAuth } from "../Admin/componants/AdminAuth";
import AdminProfile from "../Admin/pages/AdminProfile";
import PendingApprovals from "../Admin/pages/PendingApprovals";
import Subordinates from "../Admin/pages/Subordinates";
import LeadEnquiry from "../Admin/pages/LeadEnquiry";
import LeadHistory from "../Admin/pages/LeadHistory";
import StudentReport from "../Admin/pages/StudentReport";


const ProtectedAdminRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const auth = getAdminAuth();

  if (!auth?.isAuthenticated) {
    return <Navigate to="/LMS/login" replace />;
  }

  return <>{children}</>;
};

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="pending-approvals" element={<PendingApprovals />} />
        <Route path="lead-enquiry" element={<LeadEnquiry />} />
        <Route path="subordinates" element={<Subordinates />} />
        <Route path="ad-profile" element={<AdminProfile />} />
        <Route path="ad-profile/:id" element={<AdminProfile />} />
        <Route path="courses" element={<AdminCourses />} />
        <Route path="batches" element={<AdminBatches />} />
        <Route path="students" element={<AdminStudents />} />
        <Route path="teachers" element={<AdminTeachers />} />
        <Route path="questions" element={<AdminQuestionBank />} />
        <Route path="tests" element={<AdminTestSeries />} />
        <Route path="live-classes" element={<AdminLiveClasses />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="lead-history/:id" element={<LeadHistory />} />
        <Route path="student-report/:id" element={<StudentReport />} />

        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;